/* global define, zipTools, Handlebars, SU */
define('firstMoverParticipant',[
  'jquery',
  'lib/util/tda.config',
  'lib/getParameterByName',
  'storageUtil',
  'cookies',

  // side effect includes. But not all of them should be
  'gxp',
  'zipTools',
  'postMessage',
  'lib/helpers/ifCond',
], function (
  $,
  tdaConfig,
  getParameterByName,
  storageUtil,
  cookies
) {
  // FMP-6. Technically, this can and should, become a universal way to handle the pagination of
  // dealers, displaying PMA dealers first, with a 'View more Dealers' button, which, after clicked
  // will paginate through all of the dealers for a given zip code.
  // IE: perhaps this should actually be in use on the 'Dealer Specials' CTA, where right now, we ONLY EVER display PMA dealers
  // atm, this is specific for the dealers.com First Mover Participant program
  // !!!NOTE: FMP data depends on BOTH /DISREST/ below, to see if we have ANY FMP participants
  // and then /BATWS/ to get the data for each dealer (including FMP data)
  // this means that BOTH /DISREST/ and /BATWS/ need to contain the latest FMP data!!!

  window.fmp = {
    zipContainsFmp: function (zip) {
      window.fmp.lastZip = zip;
      window.bat.util.loader.showLoader();
      var zipContainsFmp = $.Deferred();
      this.participationCheck(zip, 'FMP').done(function (response) {
        zipContainsFmp.resolve(response);
      });
      return zipContainsFmp.promise();
    },

    // check for RTI (GXP)
    zipContainsRti: function (zip) {
      window.fmp.lastZip = zip;
      window.bat.util.loader.showLoader();
      var zipContainsRti = $.Deferred();
      this.participationCheck(zip, 'RTI').done(function (response) {
        zipContainsRti.resolve(response);
      });
      return zipContainsRti.promise();
    },

    // Query DIS with an attributeKey
    // we don't do anything with the results, we just need to know if ANY exist
    // TODO: if RTI check returns just one dealer AND its PMA, then skip the rest and just do RTI redirection
    participationCheck: function (zip, attr) {
      var zipContainsParticipantObj = $.Deferred();
      var hasAttr;
      // console.log('check to see if ' + zip + ' based dealer results contain ANY ' + attr + ' participants');
      var ajaxTime = Date.now();
      // ONLY CHECK IF participating TDA. Save all the other TDAs
      if (!BATSiteConfig.gxp || BATSiteConfig.gxp === 'disabled') {
        // console.log('Non participating TDA, return false');
        zipContainsParticipantObj.resolve(false);
      } else {
        $.ajax({
          dataType: 'json',
          url: '/DISREST/rest/getDealers',
          data: {
            brandId: 1,
            resultsMax: 20,
            searchMode: 'pmaProximityLayered',
            zipcode: zip,
            excludeAttributeKey: 'ServiceCenterOnly',
            appKey: '7033548c4e5e4270b5336c904c92c2e2',
            resultsMode: 'full',
            resultsFormat: 'json',
            attributeKey: attr
          },
          timeout: 10000
        }).done(function (response) {
          var noResults = $.isEmptyObject(response.showDealerLocatorDataArea);
          var totalTime = Date.now() - ajaxTime;
          if (noResults) {
            // console.log(zip + ' does NOT contain any ' + attr + ' participants. Time: ' + totalTime);
            hasAttr = false;
          } else {
            // console.log(zip + ' Contains ' + response.showDealerLocatorDataArea.dealerMetaData.length + ' ' + attr + ' participants. Time: ' + totalTime);
            hasAttr = true;
          }
          zipContainsParticipantObj.resolve(hasAttr);
        }).fail(function (response) {
          var totalTime = Date.now() - ajaxTime;
          // console.log('DIS service responded with error: ' + response.statusText + ', consider it non-' + attr + '. Time: ' + totalTime);
          zipContainsParticipantObj.resolve(false);
        });
      }
      return zipContainsParticipantObj.promise();
    },

    // TODO: move to external xform
    dealersComFormat: {
      '4runner': '4Runner',
      'avalon': 'Avalon',
      'avalonhybrid': 'Avalon+Hybrid',
      'camry': 'Camry',
      'camryhybrid': 'Camry+Hybrid',
      'corolla': 'Corolla',
      'highlander': 'Highlander',
      'highlanderhybrid': 'Highlander+Hybrid',
      'landcruiser': 'Land+Cruiser',
      'prius': 'Prius',
      'priusv': 'Prius+v',
      'rav4': 'RAV4',
      'rav4hybrid': 'RAV4+Hybrid',
      'sequoia': 'Sequoia',
      'sienna': 'Sienna',
      'tacoma': 'Tacoma',
      'tundra': 'Tundra',
      'yaris': 'Yaris'
    },

    /*-------------------------------------------------------------------------------------------
    Attach all the click events to our inventory links in individual component files
    // see: zip-tools.js (Handles all inventory links on WWW)
    // see also: offer-detail.js (Handles inventory links on offer details pages)
    // see also: AN_inventory.js (Handles inventory links on inventory detail pages)
    // see also: vehicle-info.js (Handles inventory links on all vehicle info pages, in the header and the models slideshow)
    // see also: vehicle-compare.js
    // see also: payment-calculator-results.js
    // see also: zip-tools, nationalForms.initInventoryForm

    // Builds Cookie of current vehicle clicked. That cookie is then read by FMP or GXP
    ---------------------------------------------------------------------------------------------*/
    attachInventoryClicks: function (inventoryLinkSelector, isSmartPath) {
      var that = this;
      if (isSmartPath) {
        window.zipTools.isSmartPath = true; // BAT-2990, also set in zip-tools. one set can be removed.
      }

      inventoryLinkSelector.off('click.fmp keypress.fmp').on('click.fmp keypress.fmp', function (e) {
        // BAT-4832 If tab key is pressed for naviation, skip all this
        if (e.keyCode === 9) {
          return;
        }
        e.preventDefault();
        var $this = $(this);
        var thisHref = $this.attr('href');
        var currentTDACode = window.zipTools.getCurrentTDACode();
        var currentZip = storageUtil.getZip();
        var suggestedZip = currentZip; // Suggest the one we have from the TDA they're viewing
        var isZipConfirmed = window.zipTools.verifyConfirmedZip(); // need to check on click, in case of user verifying zip w/out DOM reload
        var userSelectedDealerIsRTI = cookies.getItem('dealer_code_rti');
        var userSelectedDealerIsFMP = cookies.getItem('dealer_code_fmp');
        var autoSelectedDealerCode = cookies.getItem('dealer_code_rti_code') === '00000'; // user dismissed modals instead of selected dealers
        window.gxpBat.garage.isOffersModal = false; // Need this global var to see if we're in the offers flow if users cancels zip change
        window.gxpBat.garage.isInventoryModal = true;

        // IF TDA is SET ... skip all the FMP logic
        if (currentTDACode === 'SET10') {
          window.location.href = thisHref;
          return;
        }
        // TODO: what if ?dealercode is present in URL (if user came from "Search New Inventory" CTA on FAD page). This IS possible, but is NOT setup.
        // if zipconfirmed, and dealer_code_rti and dealer_code_fmp cookies are false, we can stop it all. just stop. OR if SET10
        // only prompt if in a participating dealer
        var participantTDA = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';
        if (!isSmartPath && (!participantTDA || (isZipConfirmed && userSelectedDealerIsRTI === 'false' && userSelectedDealerIsFMP === 'false') || autoSelectedDealerCode)) {
          that.setVehicleInfoCookie(thisHref);
          window.location.href = window.fmp.buildInventoryUrl();
          return;
        }

        /*-----------------------------------------------------------------------------
        We need to build our URL using our buildInventoryUrl() method no MATTER WHAT
        - this is because we've altered nearly every inventory link, and the 'plain old HREF' is no longer reliable
        (ie: inventory detail links look like: ?series=avalon&year=2016&trim=3544&exteriorColorCode=01J9&exteriorColor=Celestial+Silver+Metallic&interiorColorCode=LD17&engineType=3.5L+V6+24-Valve+DOHC+With+VVT-i&transmission=6-speed+ECT-i+automatic+w%2F+sequential+shift+mode)
        -------------------------------------------------------------------------------*/
        if (!isSmartPath) { // BAT-2990.
          that.setVehicleInfoCookie(thisHref);
          window.gxpBat.garage.inventoryModalUrl = thisHref;
          var redirectHref = window.fmp.buildInventoryUrl();
        }

        // zip is confirmed and it's not smartpath (see /landing/smarthpath/)
        if (isZipConfirmed && !isSmartPath) {
          if (userSelectedDealerIsRTI === 'true') {
            // console.log('GXP: dealer_code_rti is true. Build RTI URL and move along to reusable components page');
            var promisedSeries = window.fmp.buildInventoryUrlRti();
            promisedSeries.done(function (rtiUrl) {
              window.location.href = rtiUrl;
            });
          } else {
            // check for BOTH RTI and FMP:
            // see also _changeZipComplete in zipTools.js, we do the same thing there, when zip is NOT confirmed
            var promisedZipContainsFmp = window.fmp.zipContainsFmp(currentZip);
            var promisedZipContainsRti = window.fmp.zipContainsRti(currentZip);

            $.when(promisedZipContainsRti, promisedZipContainsFmp).done(function (RtiResponse, FmpResponse ) {
              // we ARE in the FMP/RTI user-flow, AND the newZip participates in either FMP || RTI
              if (RtiResponse || FmpResponse) {
                // console.log('confirmed zip contains RTI OR FMP dealer');
                window.fmp.evaluateDealersFmp(false);
              } else {
                // console.log('confirmed zip does NOT contain FMP dealer');
                // window.location.href = redirectHref;
                // BAT-3146
                window.bat.util.loader.hideLoader(false, true);
                setTimeout(function () {
                  window.location.href = redirectHref;
                }, 200);
              }
            });
          }

        // Inventory entry points: zip is NOT confirmed, we must geolocate them (or prompt for zip if no geolocate)
        // Utlimately, we end up in _changeZipComplete in zip-tools.js, where we check for participation
        // note: I left isSmartPath as-is
        } else if (isSmartPath) { // BAT-2990.
          // click is smartpath, show zip modal :::
          redirectHref = window.location.pathname;
          // showPromptUserZipModal: function(currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isSmartPath, isOffersModal){
          window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, redirectHref, '', true, false, true, false); // 7th param to indicate smartpath
        } else {
          // GXP/FMP only, geolocate if allowed, otherwise prompt
          window.fmp.getZipFromLocate = function () {
            var failCallback = function () {
              window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, redirectHref, '', true, true, false, false);
            };
            try {
              if (navigator.geolocation) {
                // try geolocation
                // detect zip, provide successCallbak and failCallback
                var geoSuccess = function (responseZip) {
                  var currentZip = SU.getZip();
                  // changeZip: function(currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal) {
                  window.zipTools.changeZip(currentZip, responseZip, '', undefined, false, true, false);
                };
                window.zipTools.geoLocationZip.detect(geoSuccess, failCallback);
              } else {
                failCallback();
              }
            } catch (e) {
              // console.log('try failed ', e);
              failCallback();
            }
          };
          window.fmp.getZipFromLocate();
        }
      });
    },

    attachOfferClicks: function (offerLinkSelector, isSmartPath) {
      var that = this;
      offerLinkSelector.off('click').on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        var thisHref = $this.attr('href');
        var currentTDACode = window.zipTools.getCurrentTDACode();
        var currentZip = SU.getZip();
        var suggestedZip = currentZip; // Suggest the one we have from the TDA they're viewing
        var isZipConfirmed = window.zipTools.verifyConfirmedZip(); // need to check on click, in case of user verifying zip w/out DOM reload
        var userSelectedDealerIsRTI = window.docCookies.getItem('dealer_code_rti');
        var autoSelectedDealerCode = window.docCookies.getItem('dealer_code_rti_code') === '00000'; // user dismissed modals instead of selected a dealer
        var temp = new Date();
        window.gxpBat.garage.isOffersModal = true; // Need this global var to see if we're in the offers flow if users cancels zip change
        window.gxpBat.garage.isInventoryModal = false;
        temp.setSeconds(temp.getSeconds() + 120); // 120 seconds for our temp cookie
        window.docCookies.removeItem('offer_selection', '/');
        window.docCookies.setItem('offer_selection', String(thisHref), temp, '/', window.zipTools.getCrossDomainCookieDomain());

        // if confirmed zip & dealer NOT participant, or if auto selected dealer was done so from dismissing modals
        if (currentTDACode === 'SET10' || (isZipConfirmed && userSelectedDealerIsRTI === 'false') || autoSelectedDealerCode) {
          window.location.href = thisHref;
          return false;
        }

        // zip is confirmed and it's not smartpath (see /landing/smarthpath/)
        if (isZipConfirmed) {
          // console.log('GXP: Zip is confirmed');

          if (userSelectedDealerIsRTI === 'true') {
            // console.log('GXP: dealer_code_rti is true. Move along to offer details page');
            window.location.href = thisHref;
          } else {
            // check for BOTH RTI and FMP:
            // see also _changeZipComplete in zipTools.js, we do the same thing there, when zip is NOT confirmed

            var promisedZipContainsRti = window.fmp.zipContainsRti(currentZip);

            $.when(promisedZipContainsRti).done(function (RtiResponse ) {
              // we ARE in the FMP/RTI user-flow, AND the newZip participates in either FMP || RTI
              if (RtiResponse) {
                // console.log('confirmed zip contains RTI dealer');
                window.fmp.evaluateDealersFmp(true);
              } else {
                // console.log('confirmed zip does NOT contain RTI dealer');
                // window.location.href = redirectHref;
                // BAT-3146
                window.bat.util.loader.hideLoader(false, true);
                setTimeout(function () {
                  window.location.href = thisHref;
                }, 200);
              }
            });
          }

        // Offer entry points zip is NOT confirmed, we must geolocate them (or prompt for zip if no geolocate)
        // Utlimately, we end up in _changeZipComplete in zip-tools.js, where we check for participation
        } else {
          window.fmp.getZipFromLocate = function () {
            var failCallback = function () {
              // showPromptUserZipModal: function(currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isSmartPath, isOffersModal){
              window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, thisHref, '', true, false, false, true);
            };
            try {
              if (navigator.geolocation) {
                // try geolocation
                // detect zip, provide successCallbak and failCallback
                var geoSuccess = function (responseZip) {
                  var currentZip = SU.getZip();
                  // changeZip: function(currentZip, newZip, redirectPath, finalCallback, isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal) {
                  window.zipTools.changeZip(currentZip, responseZip, '', undefined, false, false, true);
                };
                window.zipTools.geoLocationZip.detect(geoSuccess, failCallback);
              } else {
                failCallback();
              }
            } catch (e) {
              // console.log('try failed ', e);
              failCallback();
            }
          };
          window.fmp.getZipFromLocate();
        }
      });
    },

    setVehicleInfoCookie: function (link) {
      var that = this;
      console.log('GXP/FMP: Setting vehicle Info Cookie');
      cookies.removeItem('inventory_selection', '/', cookies.getCrossDomainCookieDomain());
      var queryString = '?' + link.split('?')[1];
      var tomorrow = new Date((new Date()).valueOf() + 1000 * 3600 * 24);
      var specificVehicleInfo = {
        ddcref: 'toyotaT2', // static, from FMP-10
        toyotaRetailRedirect: true, // static, from FMP-11
        brand: 'TOY'
      };

      if (link.indexOf('series') > -1) {
        var ogSeries = getParameterByName('series', queryString);
        var series = that.dealersComFormat[ogSeries];
        if (series == null) {
          series = ogSeries;
        }
        specificVehicleInfo.model = series;
      }

      if (link.indexOf('year') > -1) {
        var year = getParameterByName('year', queryString);
        specificVehicleInfo.year = year;
      }
      if (link.indexOf('trim') > -1) {
        var modelCode = getParameterByName('trim', queryString);
        specificVehicleInfo.modelCode = modelCode;
      }
      if (link.indexOf('selectedModels') > -1) {
        var selectedModels = getParameterByName('selectedModels', queryString);
        specificVehicleInfo.selectedModels = selectedModels.toLowerCase();
      }
      if (link.indexOf('exteriorColorCode') > -1) {
        var exteriorColorCode = getParameterByName('exteriorColorCode', queryString);
        specificVehicleInfo.exteriorColorCode = exteriorColorCode;
      }
      if (link.indexOf('exteriorColor') > -1) {
        var exteriorColor = getParameterByName('exteriorColor', queryString);
        specificVehicleInfo.exteriorColor = exteriorColor;
      }
      if (link.indexOf('interiorColorCode') > -1) {
        var interiorColorCode = getParameterByName('interiorColorCode', queryString);
        specificVehicleInfo.interiorColorCode = interiorColorCode;
      }
      if (link.indexOf('engineType') > -1) {
        var engineType = getParameterByName('engineType', queryString);
        specificVehicleInfo.engineType = engineType;
      }
      if (link.indexOf('transmission') > -1) {
        var transmission = getParameterByName('transmission', queryString);
        specificVehicleInfo.transmission = transmission;
      }
      // remove previous cookie
      cookies.setItem('inventory_selection', JSON.stringify(specificVehicleInfo), tomorrow, '/', cookies.getCrossDomainCookieDomain());
      return specificVehicleInfo;
    },

    // add an argument of true to return only the model and brand data
    readVehicleInfoCookie: function (modelOnly) {
      var modelOnly = modelOnly || false;
      var specificVehicleInfo = JSON.parse(window.docCookies.getItem('inventory_selection'));
      if (specificVehicleInfo == null) {
        return null;
      }
      var modelForBat = specificVehicleInfo.model || '';

      if (modelForBat) {
        // the tC needs to STAY as 'tC'
        if (modelForBat.toUpperCase() === 'TC') {
          modelForBat = 'tC';
        } else {
          modelForBat = modelForBat.toLowerCase();
        }

        modelForBat = modelForBat.replace('+', '');
      }

      if (modelOnly) {
        var tmpObj = {
          model: modelForBat,
          brand: specificVehicleInfo.brand
        };
        return tmpObj;
      } else {
        var urlParams = '';
        $.each(specificVehicleInfo, function (index, value) {
          // drop brand from the obj, we don't need that for our FMP iframe purposes
          if (index !== 'brand') {
            urlParams = urlParams + '&' + index + '=' + value;
          }
        });
        return urlParams;
      }
    },

    /*------------------------------------------------------------------------------------------------------
    evaluateDealersFmp
      - ONLY INVOKED IF ZIP IS CONFIRMED
        We invoke in fmp.attachInventoryClicks, above
    --------------------------------------------------------------------------------------------------------*/
    evaluateDealersFmp: function (isOffersModal) {
      // console.log('evaluating Dealers RTI / FMP status')
      var confirmedZip = SU.getZip(); // we now have a confirmed zip, it's safe to re-get.
      var selectedDealer = window.docCookies.getItem('dealer_code_rti_code');
      var userSelectedDealerIsRTI = window.docCookies.getItem('dealer_code_rti');
      var userSelectedDealerIsFMP = window.docCookies.getItem('dealer_code_fmp');

      // callback for use in window.zipTools.getTDA, which provides us with dealerdata
      var getDealerCallback = function (data) {
        var dealerCount = data.entityList.length;
        window.fmp.firstMoverParticipantDisplay(confirmedZip, data, undefined, undefined, undefined, undefined, isOffersModal);
      };

      // if there's no selectedDealer OR the dealer that IS selected, was done so OUTSIDE of the FMP flow, we need to prompt to have them select a dealer
      // User has NOT selected a dealer before
      if (!selectedDealer || userSelectedDealerIsFMP == null) {
        // console.log('@@ No previously selected dealer');
        window.zipTools.getTDA(confirmedZip, getDealerCallback);

      // user has selected a dealer before, evaluate that dealer (in buildInventoryUrl) and redirect to proper URL
      } else {
        // var properUrl = window.fmp.buildInventoryUrl();
        if (!window.zipTools.isSmartPath) {
          var properUrl = '';
          if (userSelectedDealerIsRTI === 'true') {
            var promisedSeries;
            if (isOffersModal) {
              promisedSeries = window.fmp.buildOffersUrlRti();
            } else {
              promisedSeries = window.fmp.buildInventoryUrlRti();
            }

            promisedSeries.done(function (rtiUrl) {
              if (rtiUrl !== '') {
                window.location.href = rtiUrl;
                // console.log('GXP: Selected dealer is RTI. Move on.');
              } else {
                SU.initFavorites(); // recheck if favs
                // console.log('GXP: Selected dealer is RTI. Already on proper page. Stop.');
              }
            });
          } else {
            // non-RTI, non-FMP, just carry on
            if (isOffersModal) {
              properUrl = window.fmp.buildOffersUrlRti();
              properUrl.done(function (rtiUrl) {
                if (rtiUrl !== '') {
                  window.location.href = rtiUrl;
                } else {
                  SU.initFavorites(); // recheck if favs
                }
              });
            } else {
              properUrl = window.fmp.buildInventoryUrl();
              window.location.href = properUrl;
            }
          }
          return;
        } else {
          if (window.fmp.startSearchAnew) {
            // BAT 2990: USER HAS SELECTED TO START SEARCH AGAIN FROM SMART PATH NON FMP DIALOG.
            var cb = function (data) {
              window.fmp.dealerReset(true);
              window.fmp.firstMoverParticipantDisplay(confirmedZip, data);
              $('#dealer-modal-all-gxp').show();
              $('.modal-backdrop').show();
            };
            window.zipTools.getTDA(confirmedZip, cb);
            window.fmp.startSearchAnew = false;
          }
        }
      }
    },

    // default to initial values
    dealerSearchData: {
      currentResultNum: 1,
      dealerCount: 1,
      maxResults: 5,
      dealerBegin: 1,
      dealerEnd: 5
    },

    dealerReset: function (newSearch) {
      this.dealerSearchData = {
        currentResultNum: 1,
        dealerCount: 1,
        maxResults: 5,
        dealerBegin: 1,
        dealerEnd: 5
      };
      if (!newSearch) {
        $('#dealer-modal-all-gxp').find('.modal-dialog .loader').remove();
      }
    },

    /* 'Find Inventory' links within our dealer select modal */
    buttonEvents: {
      findInventory: function () {
        var $dealerButton = $('#dealer-modal-all-gxp').find('.modal-select');
        $dealerButton.on('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          // Since user is selecting a dealer, consider the zip confirmed
          var newZip = $('.js-edit-zip').text().trim();
          SU.setZip(newZip);
          SU.setConfirmedZip(true);
          // set a transferZip, this will mark it as confirmed
          // var chosenZip = SU.getZip();
          // window.docCookies.setItem('transferZip', chosenZip, new Date(Date.now() + window.zipTools.transferZipCookieTTL), '/', window.zipTools.getCrossDomainCookieDomain());

          $('#dealer-modal-all-gxp').find('.modal-dialog').append('<div class="loader"></div>');
          var dealerCode = $(this).data('dealer');
          var fmp = $(this).data('fmp');
          var rti = $(this).data('rti'); // if this is an RTI participant, that takes precedence.
          var tdaCode = $(this).data('tda');
          var dealerurl = $(this).data('dealerurl');
          var isOffers = $('#modal-dealer-all-inner').hasClass('is-offers');
          window.fmp.setDealerCookies(dealerCode, fmp, rti, tdaCode, dealerurl);

          // BAT-2992 update data-layer with dealer block (applied in BAT-2992, but needed in OG FMP clicks too)
          var currDataLayer = $(this).data('layer');
          $.extend(window.dataLayerBAT.data, currDataLayer);
          // if this dealer is RTI participant we need to get all the series for the vehicle they clicked on

          // if this dealer is FMP (&& smartPath participant), this link becomes a key-metric link
          if (fmp && window.zipTools.isSmartPath) {
            $(this).data('km', 'km-smartpath-clickout');
          }
          window.dataLayerBAT.utils.buildAndFireLinkData($(this));

          // BAT-2990 if smartPath (/landing/smartpath/):
          if (window.zipTools.isSmartPath) {
            var smartPathUrl = '';
            if (fmp) {
              // THIS IS FMP/SMARTPATH, GO TO DEALER.
              smartPathUrl = window.fmp.buildDealerUrl(true);
              window.location.href = smartPathUrl;
              // LET'S GO!
              return;
            } else {
              // NOT FMP, PRESENT USER WITH MODAL FOR DECISION TO SEARCH FOR ANOTHER FMP/SMARTPATH DEALER
              // console.log('::: SHOW MODAL, THIS IS NOT FMP.');
              $('.loader').hide();
              $('#dealer-modal-all-gxp').modal('hide');
              // /$('.modal-backdrop').hide();

              $('#smartPath-modal').modal('show');
              $('#smartPath-modal').find('.modal-continue').off('click').on('click', function () {
                smartPathUrl = window.fmp.buildDealerUrl(false);
                window.location.href  = smartPathUrl;
                return;
              });

              var smartpathCancelBtn = $('#smartPath-modal').find('.modal-cancel');
              smartpathCancelBtn.off('click').on('click', function () {
                // window.fmp.firstMoverParticipantDisplay();
                // window.fmp.zipContainsFmp(window.fmp.lastZip);

                window.fmp.startSearchAnew = true;
                // copied from above:
                var promisedZipContainsFmp = window.fmp.zipContainsFmp(window.fmp.lastZip);
                promisedZipContainsFmp.done(function (response) {
                  // confirmed zip contains an FMP participant (response returns true)
                  if (response) {
                    // console.log('@@ confirmed zip contains FMP dealer');
                    window.fmp.evaluateDealersFmp(false);
                  // confirmed zip does NOT contain an FMP paticipant (response returns false). Carry on, as originally intended
                  } else {
                    // console.log(' @@ confirmed zip does NOT contain FMP dealer');
                    // window.location.href = redirectHref;
                  }
                });
              });
            }

          // GXP if RTI participant
          } else if (rti) {
            var promisedSeries;
            if (isOffers) {
              promisedSeries = window.fmp.buildOffersUrlRti();
            } else {
              promisedSeries = window.fmp.buildInventoryUrlRti();
            }
            var dealer_code_rti_code_temp = window.docCookies.getItem('dealer_code_rti_code_temp');
            var dealer_code = window.docCookies.getItem('dealer_code_rti_code');
            // we have an RTI dealer_code
            promisedSeries.done(function (rtiUrl) {
              var moveOn = function () {
                // hide modal no matter what (need to check to see if its open first?)
                $('#dealer-modal-all-gxp').modal('hide');
                // $('.modal-backdrop').hide();
                if (rtiUrl !== '') {
                  window.location.href = rtiUrl;
                  // console.log('GXP: Dealer selected, but new URL. Close overlay & redirect');
                } else {
                  SU.initFavorites(); // recheck if favs
                  // console.log('GXP: Dealer selected, but no new URL. Close overlay & stay');
                }
                window.docCookies.removeItem('dealer_code_rti_code_temp', '/');
              };

              // RTI dealer code is the same as new one
              if ((dealer_code_rti_code_temp != null) && (dealer_code_rti_code_temp === dealer_code)) {
                var oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
                window.docCookies.setItem('dealer_code_rti', String('true'), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
                // console.log('GXP: Same dealer selected');
                moveOn();
              // RTI dealer code is a new dealer
              } else if ((dealer_code_rti_code_temp != null) && (dealer_code_rti_code_temp !== dealer_code)) {
                window.DGDataHub.changeActiveDealer(dealer_code).then(function () {
                  moveOn();
                }).catch(function (error) {
                  // console.log('GXP: changeActiveDealer update error: ', error);
                });
              } else {
                moveOn();
              }
            });
          // FMP, non-FMP, non-smartpath, non-RTI
          } else {
            var dealer_code_rti_code_temp = window.docCookies.getItem('dealer_code_rti_code_temp');
            if (dealer_code_rti_code_temp != null) {
              var moveOn = function () {
                if (isOffers) {
                  finalUrl = window.fmp.buildOffersUrlRti();
                  finalUrl.done(function (rtiUrl) {
                    if (rtiUrl !== '') {
                      window.location.href = rtiUrl;
                    } else {
                      SU.initFavorites(); // recheck if favs
                    }
                    window.docCookies.removeItem('dealer_code_rti_code_temp', '/');
                  });
                } else {
                  finalUrl = window.fmp.buildInventoryUrl();
                  window.location.href = finalUrl;
                  window.docCookies.removeItem('dealer_code_rti_code_temp', '/');
                }
              };

              window.DGDataHub.changeActiveDealer('Toyota').then(function () {
                window.fmp.removeDealerCookies();
                // console.log('GXP: updated dealer via changeActiveDealer(\'Toyota\')');
                moveOn();
              }).catch(function (error) {
                // console.log('GXP: changeActiveDealer update error: ', error);
                moveOn();
              });
            } else {
              if (isOffers) {
                finalUrl = window.fmp.buildOffersUrlRti();
                finalUrl.done(function (rtiUrl) {
                  if (rtiUrl !== '') {
                    window.location.href = rtiUrl;
                  } else {
                    SU.initFavorites(); // recheck if favs
                  }
                  window.docCookies.removeItem('dealer_code_rti_code_temp', '/');
                });
              } else {
                var finalUrl = window.fmp.buildInventoryUrl();
                if (finalUrl !== '') {
                  window.location.href = finalUrl;
                } else {
                  SU.initFavorites(); // recheck if favs
                }
                window.docCookies.removeItem('dealer_code_rti_code_temp', '/');
              }
            }
          }
        });
      }
    },

    setDealerCookies: function (dealerCode, dealerCodeFmp, dealerCodeRti, dealerCodeTda, dealerUrl) {
      var oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
      window.docCookies.setItem('dealer_code_rti_code', String(dealerCode), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
      window.docCookies.setItem('dealer_code_fmp', String(dealerCodeFmp), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
      window.docCookies.setItem('dealer_code_rti', String(dealerCodeRti), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
      window.docCookies.setItem('dealer_code_tda', String(dealerCodeTda), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
      // BAT-2990:capture the base dealer url and add it to our template.
      window.docCookies.setItem('dealer_url', String(dealerUrl), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
    },

    setDealerTransferCookies: function () {
      // MUST use window.zipTools.getCrossDomainCookieDomain() as the cookie domain.
      // These cookies NEED to be read by whatever TDA the user is redirected to.
      var transferTime = new Date(Date.now() + window.zipTools.transferZipCookieTTL);
      window.docCookies.setItem('transferZip', SU.getZip(), transferTime, '/', zipTools.getCrossDomainCookieDomain());
      window.docCookies.setItem('dealer_code_rti_code_transfer', String(docCookies.getItem('dealer_code_rti_code')), transferTime, '/', zipTools.getCrossDomainCookieDomain());
      window.docCookies.setItem('dealer_code_fmp_transfer', String(docCookies.getItem('dealer_code_fmp')), transferTime, '/', zipTools.getCrossDomainCookieDomain());
      window.docCookies.setItem('dealer_code_rti_transfer', String(docCookies.getItem('dealer_code_rti')), transferTime, '/', zipTools.getCrossDomainCookieDomain());
      window.docCookies.setItem('dealer_code_tda_transfer', String(docCookies.getItem('dealer_code_tda')), transferTime, '/', zipTools.getCrossDomainCookieDomain());
      // BAT-2990:capture the base dealer url and add it to our template.
      window.docCookies.setItem('dealer_url_transfer', String(docCookies.getItem('dealer_url')), transferTime, '/', zipTools.getCrossDomainCookieDomain());
      // since we're transferring, can we mark zip as unconfirmed AND remove zip cookies?
      window.docCookies.removeItem('zip', '/');
      window.docCookies.removeItem('zipcode', '/');
      window.docCookies.removeItem('isConfirmedZip', '/');
    },

    removeDealerCookies: function () {
      window.docCookies.removeItem('dealer_code_rti_code', '/', window.zipTools.getCrossDomainCookieDomain());
      window.docCookies.removeItem('dealer_code_fmp', '/', window.zipTools.getCrossDomainCookieDomain());
      window.docCookies.removeItem('dealer_code_rti', '/', window.zipTools.getCrossDomainCookieDomain());
      // window.docCookies.removeItem('dealer_code_rti_code_temp', '/', window.zipTools.getCrossDomainCookieDomain());
      window.docCookies.removeItem('dealer_code_tda', '/', window.zipTools.getCrossDomainCookieDomain());
      window.docCookies.removeItem('inventory_selection', '/', window.zipTools.getCrossDomainCookieDomain());
      window.docCookies.removeItem('dealer_url', '/', window.zipTools.getCrossDomainCookieDomain());
    },

    // BAT-2990.
    buildDealerUrl: function (fmp) {
      var userSelectedDealer = window.docCookies.getItem('dealer_code_rti_code');
      // var userSelectedDealerIsFMP = window.docCookies.getItem('dealer_code_fmp');
      var userSelectedDealerTDA = window.docCookies.getItem('dealer_code_tda');
      var currentTDACode = window.zipTools.getCurrentTDACode();
      var dealerUrlCookie = window.docCookies.getItem('dealer_url');
      var zip = SU.getZip();
      var inventoryUrlFMP;
      var inventoryUrlRegular;

      /*
        if FMP: go to local results
        [ change tda rules? ]
        if NON FMP: go to /inventory.
      */
      if ( !fmp ) {
        // NOT FMP, REDIRECT TO INVENTORY.
        var inventoryURL = ('/' + tdaConfig.site.context_url + '/inventory/');
        // console.log('currentTDACode', currentTDACode, 'userSelectedDealerTDA', userSelectedDealerTDA);
        // BAT-2290: NOT FMP, ON NATIONAL, JUST HEAD OVER TO TDA INVENTORY.
        if (currentTDACode === 'WWW' && zipTools.verifyConfirmedZip()) {
          inventoryURL = '/GOTO/' + userSelectedDealerTDA + '/inventory/';
        }
        return inventoryURL;
      } else {
        // BAT-2290: VALID FMP DEALER, SEND TO THEIR INVENTORY POOL.
        var url =  dealerUrlCookie + '/new-inventory/index.htm';
        return url;
      }

      // TODO:only do this if on www and changing to TDA.
      // zipTools.changeZip('', zip, dealerURL, undefined, true, false);//, true);
    },

    // buildInventoryUrl() builds either an FMP URL, or a "regular" inventory URL
    buildInventoryUrl: function (isOffers) {
      var isOffers = isOffers || false;
      var userSelectedDealer = window.docCookies.getItem('dealer_code_rti_code');
      var userSelectedDealerIsFMP = window.docCookies.getItem('dealer_code_fmp');
      var userSelectedDealerTDA = window.docCookies.getItem('dealer_code_tda');
      var currentTDACode = window.zipTools.getCurrentTDACode();
      var urlParams = window.fmp.readVehicleInfoCookie();
      var series = window.fmp.readVehicleInfoCookie(true);
      var seriesProp = getParameterByName('series'); // GXP search page (series present in URL)
      if (series == null) {
        series = {model: ''};
      }
      // we have a seriesProp, but no vehicleInfoCookie
      if (seriesProp && urlParams == null) {
        window.fmp.setVehicleInfoCookie('?series=' + seriesProp.toLowerCase());
        var urlParams = window.fmp.readVehicleInfoCookie();
        var series = window.fmp.readVehicleInfoCookie(true);
      }
      var inventoryUrlFMP;
      var inventoryUrlRegular;

      // If userSelectedDealerTDA has not been set (that means they're not in a zip that contains FMP dealers)
      // or if the dealer_code_tda is the same as their current TDA, then we don't need to use /GOTO/
      if (!userSelectedDealerTDA || userSelectedDealerTDA === currentTDACode) {
        // if NO urlParams, then we don't need to redirect (IE: offer-details page, selecting an FMP dealer via zip code flow, when they have an RTI dealer present)
        if (!urlParams) {
          inventoryUrlFMP = '';
        } else {
          inventoryUrlFMP = '/' + tdaConfig.site.context_url + '/inventory/local-results/?dealerCode=' + userSelectedDealer + urlParams;
        }


        if (series.model === '') {
          inventoryUrlRegular = '/' + tdaConfig.site.context_url + '/inventory/';
          // on the off chance the user is on the national site, WITH a previously confirmed zip, that does NOT contain any dealer FMP info
          // AND we have no series data
          if (currentTDACode === 'WWW' && zipTools.verifyConfirmedZip()) {
            // console.log('FMP: changing zip on WWW, WITH a previously confirmed zip and NO FMP data and NO series data');
            inventoryUrlRegular = '/inventory/';
            var zip = SU.getZip();
            zipTools.changeZip('', zip, inventoryUrlRegular, undefined, true, true);
            return;
          }
        } else {
          inventoryUrlRegular = '/' + tdaConfig.site.context_url + '/inventory/results/?series=' + series.model;
          // on the off chance the user is on the national site, WITH a previously confirmed zip, that does not contain any dealer FMP info
          // BUT we DO have series data
          if (currentTDACode === 'WWW' && zipTools.verifyConfirmedZip()) {
            inventoryUrlRegular = '/inventory/results/?series=' + series.model;
            // console.log('FMP: changing zip on WWW, WITH a previously confirmed zip and NO FMP data and WITH series data');
            var zip = SU.getZip();
            // zipTools.changeZip('', zip, inventoryUrlRegular, undefined, true, false);
            zipTools.changeZip('', zip, inventoryUrlRegular, undefined, true, true);
            return;
          }
        }

      // TDA is changing, and there was a userSelectedDealerTDA available (FMP is present)
      } else {
        window.fmp.setDealerTransferCookies();
        inventoryUrlFMP = '/GOTO/' + userSelectedDealerTDA + '/inventory/local-results/?dealerCode=' + userSelectedDealer + urlParams;
        inventoryUrlRegular = '/GOTO/' + userSelectedDealerTDA + '/inventory/results/?series=' + series.model;
      }

      window.docCookies.removeItem('dealer_gxp_fmp_Entered', '/');
      // User has previously selected a dealer, and it's an FMP dealer, just go there
      if (userSelectedDealer && userSelectedDealerIsFMP === 'true' && userSelectedDealerTDA) {
        // console.log('User has a saved dealer, use that');
        // console.log('Dealer is FMP, its TDA is: ' + userSelectedDealerTDA);
        return inventoryUrlFMP;

      // Users previously selected dealer is NOT FMP
      } else if (userSelectedDealer && userSelectedDealerIsFMP === 'false' && userSelectedDealerTDA) {
        // console.log('User has a previously selected dealer, use that');
        // console.log('Dealer is NOT FMP, just carry on');
        return inventoryUrlRegular;
      } else {
        return inventoryUrlRegular;
      }
      // window.docCookies.removeItem('inventory_selection', '/', window.zipTools.getCrossDomainCookieDomain());
    },

    /*------------------------------------------------------------------------
    Promise obj to get series for selected vehicle (if needed) and return a URL for redirection to an RTI page
    returns an obj with series codes
    buildInventoryUrlRti() builds RTI URLs only, if non-RTI participant, we will not be here
    ------------------------------------------------------------------------*/
    buildInventoryUrlRti: function () {
      var series = window.fmp.readVehicleInfoCookie(true); // obj stored in cookie. we want series.model in the end (lowercase version! non-fmp version of model! returns diff data from the complete inventory_selection cookie)
      var specificVehicleInfo = JSON.parse(window.docCookies.getItem('inventory_selection'));
      var dealerCd = docCookies.getItem('dealer_code_rti_code'); // needed for RC in query string
      var dealerZip = SU.getZip(); // needed for RC in query string
      var deferredRtiUrl = $.Deferred();
      var siteHomePath = window.zipTools.getSiteHomePath();
      var userSelectedDealerTDA = window.docCookies.getItem('dealer_code_tda');
      var currentTDACode = window.zipTools.getCurrentTDACode();
      var rtiUrl;
      var entryCTA = specificVehicleInfo == null ? false : true;
      var isGxpEntryPage = window.location.href.indexOf('inventory/results') > -1 || window.location.href.indexOf('inventory-detail') > -1 || window.location.href.indexOf('local-results') > -1 ;
      // the ONLY time we have an entryPoint is when we have a specificVehicleInfo cookie present (this means they clicked a CTA)
      // this cookie is built each time an entryPoint CTA is clicked.
      // this cookie is removed, after we build the URL.

      // If user changes zip ON a GXP page (todo: OR an entry page), we need to land them elsewhere
      var isGxpPage = window.location.href.indexOf('inventory/search') > -1 || window.location.href.indexOf('inventory/details') > -1;
      var seriesProp = getParameterByName('series') || getParameterByName('model'); // GXP search page (series present in URL)

      // we're NOT switching TDAs. Proceed with building a URL for currentTDA
      // If userSelectedDealerTDA has not been set (that means they're not in a zip that contains RTI dealers)
      // or if the dealer_code_tda is the same as their current TDA, then we don't need to use /GOTO/
      if (!userSelectedDealerTDA || userSelectedDealerTDA === currentTDACode) {
        if (isGxpPage && (window.docCookies.getItem('dealer_code_rti') !== 'true')) {
          if (seriesProp) {
            rtiUrl = siteHomePath + 'inventory/results/?series=' + seriesProp.toLowerCase();
          } else {
            rtiUrl = siteHomePath + 'inventory/'; // from GXP-details
          }
        } else if (!entryCTA && !isGxpEntryPage && !isGxpPage) {
          // we don't need to go anywhere, it's not a gxpEntryPoint, not an entryCTA, and NOT a GXP page already
          rtiUrl = '';
          // console.log('GXP buildInventoryUrlRti (non entry point page)');
        } else {
          // if we're on a gxp entry point page, we need to build a series (used when changing zip TO an entry point page)
          if (isGxpEntryPage || isGxpPage) {
            series = {
              model: seriesProp
            };
          }

          if (specificVehicleInfo && specificVehicleInfo.selectedModels) {
            rtiUrl = siteHomePath + 'inventory/search/?series=' + series.model + '&zipcode=' + dealerZip + '&dealerCd=' + dealerCd + '&selectedModels=' + specificVehicleInfo.selectedModels;
            // console.log('GXP: buildInventoryUrlRti (with selectedModels): ' + rtiUrl);
          } else {
            rtiUrl = siteHomePath + 'inventory/search/?series=' + series.model + '&zipcode=' + dealerZip + '&dealerCd=' + dealerCd;
            // console.log('GXP: buildInventoryUrlRti (no selectedModels)' + rtiUrl);
          }

          // if this is the details page, and the dealerCd hasn't changed, rebuild same URL with new zip (don't really HAVE to, but should)
          var dealerCdParam = getParameterByName('dealerCd');
          if (window.location.href.indexOf('inventory/details') > -1 && (dealerCd === dealerCdParam)) {
            var seriesParam = getParameterByName('series');
            var newZip = SU.getZip();
            // console.log('GXP: Details page, no dealer change, stay put!');
            rtiUrl = siteHomePath + 'inventory/details/?vin=' + window.viewConfig.vin + '&dealerCd=' + dealerCd + '&series=' + seriesParam + '&zipcode=' + newZip;
          }
        }

      // switch TDAs with an RTI dealer
      } else {
        // remove dealer cookies and set them as transfers!
        // Set transfer dealer_code cookies, since we're changing TDAs!!
        window.fmp.setDealerTransferCookies();
        if (isGxpPage && (window.docCookies.getItem('dealer_code_rti') !== 'true')) {
          if (seriesProp) {
            rtiUrl = siteHomePath + 'inventory/results/?series=' + seriesProp;
          } else {
            rtiUrl = siteHomePath + 'inventory/'; // from GXP-details
          }
        } else if (!entryCTA && !isGxpEntryPage && !isGxpPage) {
          // we don't need to go anywhere, it's not a gxpEntryPoint
          rtiUrl = window.location.pathname;
          // console.log('GXP buildInventoryUrlRti (non entry point page): /GOTO/TDA/\'\'');
        } else {
          // if we're on a gxp entry point page, we need to build a series (used when changing zip TO an entry point page)
          if (isGxpEntryPage || isGxpPage) {
            series = {
              model: seriesProp
            };
          }
          if (specificVehicleInfo && specificVehicleInfo.selectedModels) {
            rtiUrl = siteHomePath + 'inventory/search/?series=' + series.model + '&zipcode=' + dealerZip + '&dealerCd=' + dealerCd + '&selectedModels=' + specificVehicleInfo.selectedModels;
            // console.log('GXP: buildInventoryUrlRti (with selectedModels): /GOTO/TDA/' + rtiUrl);
          } else {
            rtiUrl = siteHomePath + 'inventory/search/?series=' + series.model + '&zipcode=' + dealerZip + '&dealerCd=' + dealerCd;
            // console.log('GXP: buildInventoryUrlRti (no selectedModels) /GOTO/TDA/' + rtiUrl);
          }
        }
        rtiUrl = '/GOTO/' + userSelectedDealerTDA + rtiUrl;
        window.fmp.removeDealerCookies();
      }

      // after we used the cookie, we need to delete it (we check for it in the beginning)
      window.docCookies.removeItem('inventory_selection', '/', window.zipTools.getCrossDomainCookieDomain());
      window.docCookies.removeItem('dealer_gxp_fmp_Entered', '/');
      deferredRtiUrl.resolve(rtiUrl);
      return deferredRtiUrl.promise();
    },

    /*------------------------------------------------------------------------
    Promise obj to get offer URL for selected offer
    ------------------------------------------------------------------------*/
    buildOffersUrlRti: function () {
      var dealerCd = docCookies.getItem('dealer_code_rti_code'); // needed for RC in query string
      var dealerZip = SU.getZip(); // needed for RC in query string
      var deferredRtiUrl = $.Deferred();
      var siteHomePath = window.zipTools.getSiteHomePath();
      var userSelectedDealerTDA = window.docCookies.getItem('dealer_code_tda');
      var currentTDACode = window.zipTools.getCurrentTDACode();
      var rtiUrl;
      var moveOn = function () {
        window.docCookies.removeItem('offer_selection', '/');
        window.docCookies.removeItem('dealer_gxp_fmp_Entered', '/'); // ensure this cookie is removed! Otherwise it may not have expired
        window.docCookies.removeItem('dealer_code_rti_code_temp', '/'); // ensure this cookie is removed! Otherwise it may not have expired
        // hide modal no matter what (need to check to see if its open first?)
        $('#dealer-modal-all-gxp').modal('hide');
        window.zipTools.updateZipFields(SU.getZip());// update UI
        deferredRtiUrl.resolve(rtiUrl);
      };

      // if they're on an offer-details page already, use that for cookie val
      if (window.location.href.indexOf('offer-detail') > -1) {
        var temp = new Date();
        temp.setSeconds(temp.getSeconds() + 120); // 120 seconds for our temp cookie
        window.docCookies.removeItem('offer_selection', '/');
        window.docCookies.setItem('offer_selection', String(window.location.pathname + window.location.search), temp, '/', window.zipTools.getCrossDomainCookieDomain());
      }
      var offer_selection = window.docCookies.getItem('offer_selection');

      // If userSelectedDealerTDA has not been set (that means they're not in a zip that contains RTI dealers)
      // or if the dealer_code_tda is the same as their current TDA, then we don't need to use /GOTO/
      if (!userSelectedDealerTDA || userSelectedDealerTDA === currentTDACode) {
        rtiUrl = offer_selection;
      // switch TDAs with an RTI dealer
      } else {
        window.fmp.setDealerTransferCookies();
        rtiUrl = '/GOTO/' + userSelectedDealerTDA + '/offers/';
        window.fmp.removeDealerCookies();
        moveOn();
      }
      // if current page is eq offer_selection, don't do anything?
      if (window.location.href.indexOf('offer-detail') !== -1) {
        var dealer_code_rti = docCookies.getItem('dealer_code_rti');
        if (dealer_code_rti === 'true') {
          var dealer_code = window.docCookies.getItem('dealer_code_rti_code');
          rtiUrl = '';
          // console.log('GXP: change dealer w/out refreshing page');
          window.DGDataHub.changeActiveDealer(dealer_code).then(function () {
            window.DGDataHub.dealerCd = dealer_code;
            var saveItem = window.DGDataHub.saveItem || window.gxpBat.garage.tmpSaveitem;
            saveItem.dealerCd = dealer_code;
            window.DGDataHub.updateSaveItem(saveItem);
            SU.initFavorites(); // recheck if favs
            moveOn();
          }).catch(function (error) {
            // console.log('GXP: changeActiveDealer update error: ', error);
            rtiUrl = '';
            moveOn();
          });
        } else {
          // console.log('GXP: dealer is NOT a participant, return empty string to avoid page refresh');
          rtiUrl = '';
          window.DGDataHub.changeActiveDealer('Toyota').then(function () {
            window.fmp.removeDealerCookies();
            window.DGDataHub.dealerCd = 'Toyota';
            SU.initFavorites(); // recheck if favs
            moveOn();
          }).catch(function (error) {
            // console.log('GXP: changeActiveDealer catch: ', error);
            rtiUrl = '';
            moveOn();
          });
        }
      } else {
        moveOn();
      }

      return deferredRtiUrl.promise();
    },

    firstMoverParticipantDisplay: function (newZip, dataDealers, dealerBegin, dealerEnd, curTDA, isInventoryModal, isOffersModal) {
      var _this = this;
      var dealerBegin = dealerBegin || _this.dealerSearchData.dealerBegin;
      var dealerEnd = dealerEnd || _this.dealerSearchData.dealerEnd;
      var dealerEnd = dealerEnd || _this.dealerSearchData.dealerEnd;
      var isInventoryModal = isInventoryModal || undefined;
      var isOffersModal = isOffersModal || false;
      var newTDA = curTDA;
      if (!window.zipTools.isSmartPath && dataDealers.entityList && dataDealers.entityList.length ) {
        newTDA = dataDealers.entityList[0].tdaCode;
      };

      if (window.zipTools.isSmartPath && !curTDA) {
        newTDA = dataDealers.entityList[0].tdaCode;
      };

      var tmpDealers = [];

      // search All Dealers, based on the TDA and ZIP provided
      $.ajax({
        dataType: 'json',
        url: '/BATWS/geo/rest/searchMode/getDealerDetails',
        data: {
          begin: dealerBegin,
          end: dealerEnd,
          brand: 'toyota',
          tdacode: newTDA,
          zipcode: newZip
        },
        beforeSend: function (xhrObj) {
          xhrObj.setRequestHeader('Content-Type', 'application/json');
          xhrObj.setRequestHeader('Accept', 'application/json');
          xhrObj.overrideMimeType('application/json');
        }
      }).done(function (response) {
        window.bat.util.loader.hideLoader();
        // console.log('getDealerDetails response.dealerLocator for ' + newTDA + ' in zip: ' + newZip);
        // console.log(response.dealerLocator[0].dealerMetaDataDetail.additionalService);
        // update dealer count with total # of dealers we have
        _this.dealerSearchData.dealerCount = response.dealerCount;

        // NON-PMA Dealers (most likely)
        // build array of objects manually, since we don't have the entitylist to assist us
        if (dataDealers === '') {
        // if(dataDealers === '' || window.zipTools.isSmartPath){
          for (var i = 0; i < response.dealerLocator.length; i++) {
            var tmpObj = {
              dealerCode: response.dealerLocator[i].dealerId,
              dealerLocator: response.dealerLocator[i],
              tdaCode: newTDA
            };

            var addServices = response.dealerLocator[i].dealerMetaDataDetail.additionalService;
            for (var j = 0; j < addServices.length; j++) {
              var additionalServiceCode = addServices[j].code.value;
              var additionalServiceParticipationIndicator = addServices[j].participationIndicator;
              if (additionalServiceCode === 'FMP') {
                tmpObj.firstMover = additionalServiceParticipationIndicator;
              }
              if (additionalServiceCode === 'RTI') {
                tmpObj.realTimeInventory = additionalServiceParticipationIndicator;
              }
            }

            tmpDealers.push(tmpObj);
          }
          /*
          console.group('tmpDealers, first OBJ, NEXT time around');
          console.log(tmpDealers[0]);
          console.groupEnd();
          */
        } else {
          // add dealerLocator data to each dealer
          for (var x = 0; x < dataDealers.entityList.length; x++) {
            dataDealers.entityList[x].tdaCode = newTDA; // manually add a TDACODE to each dealer
            for (var i = 0; i < response.dealerLocator.length; i++) {
              if (response.dealerLocator[i].dealerId === dataDealers.entityList[x].dealerCode) {
                dataDealers.entityList[x].dealerLocator = response.dealerLocator[i];
                // BAT-2290: tack on the dealer url. will come in handy later.
                dataDealers.entityList[x].dealerUrl = response.dealerLocator[i].dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact['0'].uricommunication['0'].uriid.value;
                //  dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].uricommunication
                var addServices = response.dealerLocator[i].dealerMetaDataDetail.additionalService;
                for (var j = 0; j < addServices.length; j++) {
                  var additionalServiceCode = addServices[j].code.value;
                  var additionalServiceParticipationIndicator = addServices[j].participationIndicator;
                  if (additionalServiceCode === 'FMP') {
                    dataDealers.entityList[x].firstMover = additionalServiceParticipationIndicator;
                  }
                  if (additionalServiceCode === 'RTI') {
                    dataDealers.entityList[x].realTimeInventory = additionalServiceParticipationIndicator;
                  }
                }
                tmpDealers.push(dataDealers.entityList[x]);
              }
            }
          }
        }

        // If there's only a single dealer, set zip as confirmed, set the FMP related cookies, and build the proper Inventory URL
        if (response.dealerCount === 1) {
          // console.log('There\'s only a single dealer, auto-save this dealer');
          SU.setZip(newZip);
          SU.setConfirmedZip(true);
          window.fmp.setDealerCookies(tmpDealers[0].dealerCode, tmpDealers[0].firstMover, tmpDealers[0].realTimeInventory, tmpDealers[0].tdaCode, tmpDealers[0].dealerUrl);
          // we may be here from a zip code change initiated with an active RTI dealer. If so, we can check for dealer_code_rti_code_temp cookie, set in gxp.js zip listener
          var dealer_code_rti_code_temp = window.docCookies.getItem('dealer_code_rti_code_temp');
          var dealer_code_rti = window.docCookies.getItem('dealer_code_rti_code');
          if (dealer_code_rti_code_temp != null) {
            // if new dealerCode matches old dealerCode, don't remove RTI, and don't leave this page.
            if (dealer_code_rti_code_temp === dealer_code) {
              var oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
              window.docCookies.setItem('dealer_code_rti', String('true'), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
              // console.log('GXP: Same dealer selected. Leave things as-is')
            } else {
              var promisedSeries;
              if (isOffersModal) {
                promisedSeries = window.fmp.buildOffersUrlRti();
              } else {
                promisedSeries = window.fmp.buildInventoryUrlRti();
              }

              promisedSeries.done(function (rtiUrl) {
                window.DGDataHub.changeActiveDealer('Toyota').then(function () {
                  window.fmp.removeDealerCookies();
                  // console.log('GXP: Single dealer. user had a garage (with or without items)');
                  // console.log('GXP: updated dealer via changeActiveDealer(\'Toyota\')');
                  // only change location if we're on a GXP entry point page!
                  if (rtiUrl !== '') {
                    window.location.href = rtiUrl;
                  } else {
                    SU.initFavorites(); // recheck if favs
                  }
                }).catch(function (error) {
                  // console.log('GXP: changeActiveDealer update error: ', error);
                });
              });
            }
          } else if (isOffersModal) {
            window.fmp.buildOffersUrlRti().done(function (rtiUrl) {
              if (rtiUrl !== '') {
                window.location.href = rtiUrl;
              } else {
                SU.initFavorites(); // recheck if favs
              }
            });
          } else if (dealer_code_rti) {
            window.fmp.buildInventoryUrlRti().done(function (rtiUrl) {
              if (rtiUrl !== '') {
                window.location.href = rtiUrl;
              } else {
                window.location.href = window.fmp.buildInventoryUrl();
              }
            });
          } else {
            window.location.href = window.fmp.buildInventoryUrl();
          }
        } else {
          // console.log('Multiple dealers found for this zip');
          _this.dealerSearchComplete(tmpDealers, newZip, newTDA, isOffersModal);
        }
      });
    },

    // modeled after onSearchComplete in dealer-panel.js
    dealerSearchComplete: function (dealerArr, curZip, curTDA, isOffersModal) {
      var _this = this;
      var pmaDealerData;
      var dealerDataForDisplay;
      // if currentResultNum === 1, then we need to default the modal to display ONLY PMA Dealers
      // Handles first modal open, and when clicking on 'View More Dealers'
      if (_this.dealerSearchData.currentResultNum === 1) {
        pmaDealerData = $.grep(dealerArr, function (element, index) {
          return element.pma;
        });
        if (pmaDealerData.length) {
          // we have pma dealers to display
          dealerDataForDisplay = pmaDealerData;

          // There's only a single PMA dealer, AND that dealer is FMP || RTI
          // then auto-select that dealer, and go to its FMP or RTI  page
          if (pmaDealerData.length === 1 && (pmaDealerData[0].firstMover || pmaDealerData[0].realTimeInventory)) {
            // console.log('There\'s only a single PMA dealer and it\'s either FMP or RTI. Auto-save it.');
            SU.setZip(curZip);
            SU.setConfirmedZip(true);
            window.fmp.setDealerCookies(pmaDealerData[0].dealerCode, pmaDealerData[0].firstMover, pmaDealerData[0].realTimeInventory, pmaDealerData[0].tdaCode, pmaDealerData[0].dealerUrl);

            if (!window.zipTools.isSmartPath) {
              // RTI takes precedence, build the RTI URL
              var dealer_code_rti_code_temp = window.docCookies.getItem('dealer_code_rti_code_temp');
              var dealer_code = window.docCookies.getItem('dealer_code_rti_code');
              if (pmaDealerData[0].realTimeInventory) {
                var promisedSeries;
                if (isOffersModal) {
                  promisedSeries = window.fmp.buildOffersUrlRti();
                } else {
                  promisedSeries = window.fmp.buildInventoryUrlRti();
                }

                promisedSeries.done(function (rtiUrl) {
                  var moveOn = function () {
                    if (rtiUrl !== '') {
                      window.location.href = rtiUrl;
                      // console.log('GXP: Auto-saved dealer is RTI. Move on.');
                    } else {
                      SU.initFavorites(); // recheck if favs
                      // console.log('GXP: Auto-saved dealer is RTI. Already on proper page. Stop.');
                    }
                  };

                  if (dealer_code_rti_code_temp != null) {
                    // console.log('GXP: user had a garage')
                    if (dealer_code_rti_code_temp === dealer_code) {
                      var oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
                      window.docCookies.setItem('dealer_code_rti', String('true'), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
                      moveOn();
                    } else {
                      window.DGDataHub.changeActiveDealer(dealer_code).then(function () {
                        moveOn();
                        // console.log('GXP: updated dealer via changeActiveDealer("' + dealer_code + '")');
                      });
                    }
                  } else {
                    moveOn();
                  }
                });
              } else {
                // console.log('FMP: Auto-saved dealer is FMP. Move on to FMP page.');
                if (dealer_code_rti_code_temp != null) {
                  // console.log('GXP: Auto-saved dealer is NOT GXP, and user had a garage. set it to Toyota.');
                  window.DGDataHub.changeActiveDealer('Toyota').then(function (res) {
                    window.fmp.removeDealerCookies();
                    window.location.href = window.fmp.buildInventoryUrl();
                  });
                } else {
                  window.location.href = window.fmp.buildInventoryUrl();
                }
              }
            } else {
              // BAT-2990 redirect to new inventory for single fmp.
              var newUrl = pmaDealerData[0].dealerUrl + '/new-inventory/index.htm';
              // BAT-2992 first, fire off datalayer click event for this "auto-saved" FMP participant
              var dataToAdd = {
                'dealer_brand': 'toyota',
                'dealer_code': pmaDealerData[0].dealerLocator.dealerId,
                'dealer_name': pmaDealerData[0].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.companyName.value,
                'dealer_zipcode': pmaDealerData[0].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.postcode.value,
                'dealer_city': pmaDealerData[0].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.cityName.value,
                'dealer_state': pmaDealerData[0].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.stateOrProvinceCountrySubDivisionID.value,
                'dealer_metro': pmaDealerData[0].dealerLocator.dealerLocatorDetail.dealerParty.specifiedOrganization.divisionCode.name
              };
              $.extend(window.dataLayerBAT.data, dataToAdd);
              $('.smartpath-btn#shopBtn').data('km', 'km-smartpath-clickout');// why do we have two #shopBtn's in the DOM? Oh well...
              window.dataLayerBAT.utils.buildAndFireLinkData($('#shopBtn'));
              window.location.href = newUrl;
            }
            return;

          // ONE PMA, NOT a participant of either RTI or FMP
          } else if (pmaDealerData.length === 1 && (!pmaDealerData[0].firstMover || !pmaDealerData[0].realTimeInventory)) {
            // console.log('GXP: There\'s only a single PMA dealer and it\'s NOT FMP or RTI.')
            // console.log('GXP: Auto-save this dealer and move on');
            SU.setZip(curZip);
            SU.setConfirmedZip(true);
            window.fmp.setDealerCookies(pmaDealerData[0].dealerCode, pmaDealerData[0].firstMover, pmaDealerData[0].realTimeInventory, pmaDealerData[0].tdaCode);
            // we may be here from a zip code change initiated with an active RTI dealer. If so, we can check for dealer_code_rti_code_temp cookie, set in gxp.js zip listener
            var dealer_code_rti_code_temp = window.docCookies.getItem('dealer_code_rti_code_temp');
            if (dealer_code_rti_code_temp != null) {
              var promisedSeries;
              if (isOffersModal) {
                promisedSeries = window.fmp.buildOffersUrlRti();
              } else {
                promisedSeries = window.fmp.buildInventoryUrlRti();
              }
              promisedSeries.done(function (rtiUrl) {
                // console.log('GXP: One PMA, New dealer is not a particpant, remove it');
                window.DGDataHub.changeActiveDealer('Toyota').then(function (res) {
                  window.fmp.removeDealerCookies();
                  if (rtiUrl !== '') {
                    window.location.href = rtiUrl;
                  } else {
                    SU.initFavorites(); // recheck if favs
                  }
                }).catch(function (error) {
                  // console.log('GXP: changeActiveDealer update error: ', error);
                });
              });
            } else {
              // console.log('GXP: user did NOT have a garage');
              var finalUrl;
              if (isOffersModal) {
                finalUrl = window.fmp.buildOffersUrlRti();
                finalUrl.done(function (rtiUrl) {
                  if (rtiUrl !== '') {
                    window.location.href = rtiUrl;
                  } else {
                    SU.initFavorites(); // recheck if favs
                  }
                });
              } else {
                finalUrl = window.fmp.buildInventoryUrl();
                window.location.href = finalUrl;
              }
            }
            return;
          }
          // console.log("dealerdata",dealerDataForDisplay);
        } else {
          dealerDataForDisplay = dealerArr;
        }
        // set ordering
        $.each(dealerDataForDisplay, function (index, value) {
          value.resultCount = (index + 1);
        });

        // First, open modal and update template to show only PMA dealers.
        var tmpPmaDealersTemplateData = window.zipTools._getConfirmDealerTemplateData(dealerDataForDisplay);
        // _getConfirmDealerTemplateData removes a bunch of data that we actually need, so let's add that back on
        // firstMover, tdaCode, and we tack on curZip for use by the front end

        for (var i = 0; i < tmpPmaDealersTemplateData.length; i++) {
          tmpPmaDealersTemplateData[i].firstMover = dealerDataForDisplay[i].firstMover.toString();
          tmpPmaDealersTemplateData[i].realTimeInventory = dealerDataForDisplay[i].realTimeInventory.toString();
          tmpPmaDealersTemplateData[i].tdaCode = dealerDataForDisplay[i].tdaCode;
          tmpPmaDealersTemplateData[i].curZip = curZip;
          // tmpPmaDealersTemplateData[i].dealerUrl = dealerDataForDisplay[i].dealerUrl;
        }
        // tack on the tdaCode for use in our HB template
        /* tmpPmaDealersTemplateData[0].tdaCode = dealerDataForDisplay[0].tdaCode;
        tmpPmaDealersTemplateData[0].curZip = curZip; */

        // BAT-2990. the tdaCode was getting lost in paginating ( 'next grouping'). used in else clause below.
        window.fmp.resultGroupTDA = dealerDataForDisplay[0].tdaCode;

        // show modal, pass in zip for this set of dealers
        _this.showAllDealerModal(tmpPmaDealersTemplateData, isOffersModal);

        // If there's more dealers to display after the PMA dealers,
        // store that as .data() on our 'View more dealers'
        // and we can skip another ajax call when that button is clicked (invoke dealerSearchComplete)
        if (pmaDealerData.length !== dealerArr.length) {
          dealerArr[0].curZip = curZip;
          var $moreButton = $('#dealer-modal-all-gxp').find('.js-dealers-more');

          // store pending search data (the original data)
          // self.$searchMoreBtn.data('pendingSearchData', dealerArr);
          $moreButton.data('pendingSearchData', dealerArr);

          $moreButton.on('click', function (e) {
            e.preventDefault();
            $('#dealer-modal-all-gxp').find('.modal-dialog').append('<div class="loader"></div>');
            _this.dealerSearchData.currentResultNum++;
            var moreData = $(this).data('pendingSearchData');
            _this.dealerSearchComplete(moreData, curZip, curTDA, isOffersModal);
          });
        // NO More dealers to show beyond what's current
        } else {
          $('#dealer-modal-all-gxp').find('.js-dealers-more').hide();
          // TODO: handle NON-PMA dealers on first page of results?
          // as of 6/29/2016, FMP zip code participants all have a PMA dealer, so we're OK
        }
        _this.buttonEvents.findInventory();
      /*----------------------------------------------------------------------
        else, user is already viewing modal, just update it instead.
        this accounts for after the 'View more dealers' button was clicked
        AND for pagination links
      ----------------------------------------------------------------------*/
      } else {
        $('#dealer-modal-all-gxp').find('.modal-dialog .loader').fadeOut();
        var allDealers = zipTools._getConfirmDealerTemplateData(dealerArr);
        for (var i = 0; i < allDealers.length; i++) {
          allDealers[i].firstMover = dealerArr[i].firstMover.toString();
          allDealers[i].realTimeInventory = dealerArr[i].realTimeInventory.toString();
          allDealers[i].tdaCode = dealerArr[0].tdaCode ? dealerArr[0].tdaCode : window.fmp.resultGroupTDA; // BAT-2990 NOTE: SEE ABOVE.
          allDealers[i].curZip = curZip;
        }

        var dealerCount = _this.dealerSearchData.dealerCount;
        var dealerEnd = _this.dealerSearchData.dealerEnd;
        var dealerBegin = _this.dealerSearchData.dealerBegin;
        var pageEnd;
        var pageStart;

        // Hide / Show next / prev links
        if (dealerEnd >= dealerCount) {
          pageEnd = dealerCount;
        } else {
          pageEnd = dealerEnd;
        }

        if (dealerBegin === 1) {
          pageStart = 1;
        } else {
          pageStart = dealerBegin;
        }


        var paginationObj = {
          show: true,
          pageStart: pageStart,
          pageEnd: pageEnd,
          dealerCount: dealerCount
        };

        var data = {
          dealerResults: allDealers,
          pagination: paginationObj
        };

        var soureceTemplate = $('#dealer-all-modal-inner').html();
        var resultTemplate = Handlebars.compile(soureceTemplate);
        $('#modal-dealer-all-inner').html(resultTemplate(data));

        var $nextButton = $('#dealer-modal-all-gxp').find('.js-dealers-next');
        var $prevButton = $('#dealer-modal-all-gxp').find('.js-dealers-prev');
        var $editZip = $('#dealer-modal-all-gxp').find('.js-edit-zip');

        // show next & Prev navigation
        $nextButton.off('click');
        $nextButton.on('click', function (e) {
          e.preventDefault();
          $('#dealer-modal-all-gxp').find('.modal-dialog .loader').fadeIn();
          var dealerBegin = _this.dealerSearchData.dealerBegin + _this.dealerSearchData.maxResults;
          var dealerEnd = _this.dealerSearchData.dealerEnd + _this.dealerSearchData.maxResults;

          _this.dealerSearchData.dealerBegin = dealerBegin;
          _this.dealerSearchData.dealerEnd = dealerEnd;
          // now update what the next page will be
          // search again!
          _this.firstMoverParticipantDisplay(curZip, '', dealerBegin, dealerEnd, curTDA, isOffersModal);
        });

        $prevButton.off('click');
        $prevButton.on('click', function (e) {
          e.preventDefault();
          $('#dealer-modal-all-gxp').find('.modal-dialog .loader').fadeIn();
          var dealerBegin = _this.dealerSearchData.dealerBegin - _this.dealerSearchData.maxResults;
          var dealerEnd = _this.dealerSearchData.dealerEnd - _this.dealerSearchData.maxResults;
          _this.dealerSearchData.dealerBegin = dealerBegin;
          _this.dealerSearchData.dealerEnd = dealerEnd;
          _this.firstMoverParticipantDisplay(curZip, '', dealerBegin, dealerEnd, curTDA, isOffersModal);
        });

        // click event for changing zip code
        $editZip.off('click');
        $editZip.on('click', function (e) {
          e.preventDefault();
          $('.modal.fade.in').find('.close-ground').trigger('click');
          // console.log('Changing zip from within modal');
          var currentZip = SU.getZip();
          var suggestedZip = currentZip; // Suggest the one we have from the TDA they're viewing
          var redirectHref;// = window.fmp.buildInventoryUrl();
          if (window.zipTools.isSmartPath) {
            redirectHref = window.location.pathname;
            window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, redirectHref, '', false, true, true, false);
          } else if (isOffersModal) {
            redirectHref = window.fmp.buildOffersUrlRti();
            redirectHref.done(function (rtiUrl) {
              window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, rtiUrl, '', false, false, false, true);
            });
          } else {
            redirectHref = window.fmp.buildInventoryUrl();
            window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, redirectHref, '', false, true, false, false);
          }
          // reinit change zip flow.
        });
        _this.buttonEvents.findInventory();
      }
    },

    // User may refuse dealer selection in 3 possible ways:
    // dismisses zip modal right off the bat
    // enters zip, but dismisses dealer select modal
    // user is geolocated to another TDA but dismisses the "Continue to TDA" modal
    // "modeled" after $zipModalConfirm.off('hidden.bs.modal'), zip-tools.js
    // TODO: if non-participant, allow user to continue w/unconfirmed zip. Move this to zip-tools?
    refuseSelect: function () {
      // console.log('%c GXP: User may be refusing to enter zip, continue with TDA change or select a dealer. (Modal closed and no dealer selection made)', 'background: green; color: white; display: block;');
      var participantTDA = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';
      var isOffersModal = window.gxpBat.garage.isOffersModal;
      var isInventoryModal = window.gxpBat.garage.isInventoryModal;
      var promisedSeries;
      var dealer_code_rti = window.docCookies.getItem('dealer_code_rti');
      var dealer_code_rti_code_temp = window.docCookies.getItem('dealer_code_rti_code_temp');
      var oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
      window.docCookies.removeItem('dealer_gxp_fmp_Entered', '/'); // if we dont remove this, the next zip change flow enter wont trigger the GXP flow enter
      if (SU.getTDA() !== 'WWW') {
        if (participantTDA && (dealer_code_rti == null && dealer_code_rti_code_temp !== null)) {
          window.docCookies.setItem('dealer_code_rti', String('true'), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
          window.zipTools.updateZipFields(SU.getZip());
        }
        // Only need to do this if we don't already have a saved dealer
        if (participantTDA && (dealer_code_rti == null && dealer_code_rti_code_temp == null)) {
          // Allow them to continue on regular BAT with NO dealer selected.
          window.fmp.setDealerCookies('00000', false, false, SU.getTDA(), '');
          if (isOffersModal) {
            promisedSeries = window.fmp.buildOffersUrlRti();
            promisedSeries.done(function (rtiUrl) {
              if (rtiUrl !== '') {
                window.location.href = rtiUrl;
              } else {
                SU.initFavorites(); // recheck if favs
              }
              if (zipTools.verifyConfirmedZip()) {
                window.zipTools.updateZipFields(SU.getZip());
              } else {
                window.zipTools.updateZipFields('');
              }
            });
          } else if (isInventoryModal) {
            properUrl = window.fmp.buildInventoryUrl();
            window.location.href = properUrl;
          } else {
            window.bat.util.loader.hideLoader();
          }
        } else {
          if (zipTools.verifyConfirmedZip()) {
            window.zipTools.updateZipFields(SU.getZip());
          } else {
            window.zipTools.updateZipFields('');
          }
          window.bat.util.loader.hideLoader();
        }
      }
    },

    showAllDealerModal: function (templateData, isOffersModal) {
      window.dataLayerBAT.utils.triggerEvent(document, 'DL.PAGE_LOAD'); // BAT-2992
      var _this = this;
      var $dealerAllModalInner = $('#dealer-all-modal-inner');

      var paginationObj = {
        show: false
      };

      var data = {
        dealerResults: templateData,
        pagination: paginationObj
      };

      // Dealer Confirm Modal
      if ($dealerAllModalInner.length) {
        var soureceTemplate = $dealerAllModalInner.html();
        var resultTemplate = Handlebars.compile(soureceTemplate);
        $('#modal-dealer-all-inner').html(resultTemplate(data));
        if (isOffersModal) {
          $('#modal-dealer-all-inner').addClass('is-offers');
        }
      }

      // launch modal
      var $dealerModalAll = $('#dealer-modal-all-gxp');
      $dealerModalAll.modal('show');
      $dealerModalAll.focus();

      $dealerModalAll.off('hidden.bs.modal').on('hidden.bs.modal', function (event) {
        // updates front end to users zip, wether they have actually selected a dealer or not (allows user to close dealer select modal w/out selecting a dealer, and our BAT UI updates zip fields)
        if (zipTools.verifyConfirmedZip()) {
          window.zipTools.updateZipFields(SU.getZip());
        } else {
          window.zipTools.updateZipFields('');
        }
        var dealer_code_rti = window.docCookies.getItem('dealer_code_rti');
        var dealer_code_rti_code_temp = window.docCookies.getItem('dealer_code_rti_code_temp');
        window.docCookies.removeItem('dealer_gxp_fmp_Entered', '/'); // if we dont remove this, the next zip change flow enter wont trigger the GXP flow enter
        var oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
        // we HAD an RTI dealer. But that was deleted via gxp.js zipFlowEnter.
        // if we STILL don't have an dealer_code_rti cookie, that means the user is manually closing this overlay
        // it's safe to just reset it to true
        if (dealer_code_rti == null && (dealer_code_rti_code_temp !== null)) {
          window.docCookies.setItem('dealer_code_rti', String('true'), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
        // GXP-45, if no dealer previously selected and they just close the modal w/out selecting a dealer...
        } else if (dealer_code_rti == null) {
          window.fmp.refuseSelect();
        }
        window.docCookies.removeItem('dealer_code_rti_code_temp', '/');
        // also change dealer_code_rti back to true?
        _this.dealerReset();
        $dealerModalAll.off('hidden.bs.modal');
      });

      // click event for changing zip code
      $('a.js-edit-zip').off('click').on('click', function (e) {
        e.preventDefault();
        $dealerModalAll.off('hidden.bs.modal'); // remove the hidden.bs.modal close event... the user is still trying to edit their zip code (BAT-3297)
        $('.modal.fade.in').find('.close-ground').trigger('click');
        // console.log('Changing zip from within modal');
        var currentZip = SU.getZip();
        var suggestedZip = currentZip; // Suggest the one we have from the TDA they're viewing
        var redirectHref;// = window.fmp.buildInventoryUrl();
        if (window.zipTools.isSmartPath) {
          redirectHref = window.location.pathname;
          window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, redirectHref, '', false, true, true, false);
        } else if (isOffersModal) {
          var dealer_code_rti_code_temp = window.docCookies.getItem('dealer_code_rti_code_temp');
          if (dealer_code_rti_code_temp !== null) { // if we HAD a dealer (dealer_code_rti_code_temp), we can't use buildOffersUrlRti() (BAT-3297)
            window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, '', '', false, false, false, true);
          } else {
            redirectHref = window.fmp.buildOffersUrlRti();
            redirectHref.done(function (rtiUrl) {
              window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, rtiUrl, '', false, false, false, true);
            });
          }
        } else {
          redirectHref = window.fmp.buildInventoryUrl();
          window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, redirectHref, '', false, true, false, false);
        }
      });
    }
  };

  $(window).on('loaded', function () {
    // ON CIN & DVR, attachInventoryClicks on offer-detail links.
    // if ((SU.getTDA() === 'CIN10') || SU.getTDA() === 'DVR10'){
    var participantTDA = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';
    if (participantTDA) {
      $(window).on('OFFERS.COMPLETE', function () {
        var dealer_code_rti = window.docCookies.getItem('dealer_code_rti');
        // Only do this if they dont have a previously selected dealer?
        if (dealer_code_rti == null) {
          var $offerDetailLinks = $('div.card-content a.border-all');
          window.fmp.attachOfferClicks($offerDetailLinks, false);
        }
      });
    }

    setTimeout(function () {
      var $fmpIframe = $('#page-fmp-iframe');
      // BAT-2990
      if ($('.smartpath-head-con').length > 0) {
        var $btns = $('.smartpath-btn');
        window.fmp.attachInventoryClicks($btns, true);
      }

      if ($fmpIframe.length) {
        // remove KBB and estimator links (BAT-2250). Add back in (BAT-3011)
        // $('a[href$="/trade-in-value/index.page"], a[href$="/payment-estimator/index.page"]').parent('li').remove();
        var iframeSrc = $fmpIframe.data('src');
        iframeSrc = iframeSrc + window.location.search;
        $fmpIframe.html('<iframe id="ddc-content" onload="window.scrollTo(0,0)" width="100%" height="100%" frameborder="0" scrolling="no" src="' + iframeSrc + '" style="overflow: hidden;"></iframe>');

        var setIframeHeight = function (height) {
          $fmpIframe.children('iframe').height(height);
          // console.log('updated height');
          window.bat.util.loader.hideLoader();
        };
        // Aug 3, 2017, dealer.com no longer sending postMessage, just setIframeHeight. If it happens to come back, we are still listening for the event
        setIframeHeight(3000);

        // Send window.scrollY position to DDC iframe via native postMessage
        var sendBatScrollPosition = function () {
          var frame = document.getElementById('ddc-content');
          var iframeOffset = $(frame).offset().top;
          var scrollY = window.pageYOffset;
          var hViewport = window.innerHeight; // BAT-2390

          if (iframeOffset > scrollY) {
            iframeOffset = 0;
            hViewport -= iframeOffset;  // BAT-2390
          } else {
            iframeOffset = scrollY - iframeOffset;
          }
          // console.log('FMP, iframeOffset: ', iframeOffset);
          // frame.contentWindow.postMessage(iframeOffset, '*');
          // BAT-2390 update:
          frame.contentWindow.postMessage({scrollPos: iframeOffset, clientHeight: hViewport }, '*');
        };

        // Receive postMessages from Dealer.com iframe
        $.receiveMessage(function (event) {
          var msgString = event.data;
          var messageObj;
          // Handle plain JSON OR stringified JSON (BAT-2295, alludes to dealer.com iframe using both in their postMessage)
          try {
            messageObj = JSON.parse(msgString);
          } catch (error) {
            // if plain JSON is passed in (that's what is currently in place here: https://static.dealer.com/dist/v9/variations/oem-toyota/0002/v1/js/icrossing.min.js?1473871107000)
            messageObj = JSON.parse('{"' + decodeURI(msgString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
            // console.log(error);
          }

          if (messageObj.method === 'scrollToTop') {
            window.scrollTo(0, 0);
          } else {
            setIframeHeight(messageObj.height);
          }
          sendBatScrollPosition();
        });

        $(window).on('scroll', function () {
          sendBatScrollPosition();
        });
      }
    }, 1000);
  });
  return window.fmp;
});

